import React, { PropTypes, Component } from 'react'
import style from './style.css';
import HomeIcon from 'react-icons/lib/io/home'
import FaSearch from 'react-icons/lib/io/ios-search-strong'
import FaCaretDown from 'react-icons/lib/fa/caret-down'
import FaChevronLeft from 'react-icons/lib/io/chevron-left'
import FaBars from 'react-icons/lib/io/navicon'
import { withRouter } from 'react-router-dom'
import {connect} from 'react-redux';
import {toggleBookingPanel} from '../../store/reducers';
import RippleLink from '../ripplelink';


class SmallHeader extends Component {

    constructor(props){
        super(props)
        this._show_nav_menu = this._show_nav_menu.bind(this);
        this._go_home = this._go_home.bind(this);
        this._show_booking_request = this._show_booking_request.bind(this);
    }

    _show_nav_menu(){
        this.props.history.push('/sitemap');      
    }
    _go_home(){
        this.props.history.push('/');      
    }
    _show_booking_request(){
        this.props.history.push('/booking_request');      
    }

    //<FaHome className={ style.homeIcon } />
    render() {
        const { panel_status } =  this.props
        return (
            <div className={ style.smallHeader }>
                <div className={ `${style.iconsBar} ${this.props.opaque ? style.opaque : ''}` }>
                    
                    <div className={ style.homeIcons }>
                        { this.props.backNav &&
                            <a onClick={ () => { this._go_home() } } className={ style.backIcon }><FaChevronLeft  /> </a> }   
                            <a  onClick={() => { this._go_home() } } className={ style.homeIcon }><HomeIcon /></a>
                        </div>
                    
                    <div className={ style.bookYourStayBtn } >
                        <a>
                            مجلة حواء
                        </a>
                    </div>
                    <div className={ style.iconsGroup }>
                        <a onClick={ () => { this._show_nav_menu() } }  className={ style.menuIcon } ><FaBars /></a>
                    </div>
                </div>
            </div>
        )
    }
}
//<FaSearch className={ style.searchIcon } />


export default withRouter(connect( 
    state =>({
        browser: state.browser,
        booking_panel: state.app.booking_panel,
        panel_status: state.app.booking_panel.on,
    }), 
    dispatch => { return {} }
)(SmallHeader));



// WEBPACK FOOTER //
// ./src/components/smallheader/index.js